import * as React from 'react';
import { Layout, Col, Row, Input } from 'antd';
import AppMenu from '../../AppMenu';
import LandingPageMenu from '../../LandingPageMenu';
import AppRoute from '../../../../Core/models/AppRoute';
import Logo, { DarkLogo } from '../../../Styled/Logo';
import UserBar from '../../UserBar';
import { logoLayoutSizes, menuLayoutSizes, authBarLayoutSizes, LightHeader, DarkHeader, loggedInAuthBarLayoutSizes, loggedInMenuLayoutSizes } from './TopBar.Styled';
import AuthBar from 'components/Layout/AuthBar';
import { RightAlignedRow } from '../../../Styled/Layout/RightAlignedRow';
import AuthContext from '../../../../Context/AuthContext';
import { CenterAlignedRow } from '../../../Styled/Layout/CenterAlignedRow';
import Utility from '../../../../Core/Utility';
import { Operations } from '../../../../Core/Api/Api';

const { Header } = Layout;
const { Search } = Input;

export interface Props {
    children?: React.ReactNode;
    menu: AppRoute[];
}

export interface State { }

export default class TopBar extends React.Component<Props, State> {
    static contextType = AuthContext;
    context!: React.ContextType<typeof AuthContext>;

    constructor(props: Props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <DarkHeader>
                <Row type="flex" align="middle">
                    <Col {...logoLayoutSizes} >
                        <Logo disableLinking={false} />
                    </Col>
                    {this.context.data && !Utility.HasOperations(this.context.data, [Operations.Guest_Login]) ?
                        <>  <Col {...loggedInMenuLayoutSizes}>
                            <CenterAlignedRow type="flex" justify="center">
                                <Col span={24} >
                                    <AppMenu mode="horizontal" menu={this.props.menu} />
                                </Col>
                            </CenterAlignedRow>
                        </Col>

                            <Col {...loggedInAuthBarLayoutSizes}>
                                <RightAlignedRow  >
                                    <Col span={24}>
                                        <AuthBar />
                                    </Col>
                                </RightAlignedRow>
                            </Col>
                        </>
                        :
                        <>  <Col {...menuLayoutSizes}>
                            <CenterAlignedRow type="flex" justify="center">
                                <Col span={24} >
                                  {/*  <AppMenu mode="horizontal" menu={this.props.menu} />*/}
                                </Col>
                            </CenterAlignedRow>
                            </Col>
                            <Col {...authBarLayoutSizes}>
                                <RightAlignedRow  >
                                    <Col span={24}>
                                        <AuthBar />
                                    </Col>
                                </RightAlignedRow>
                            </Col>
                        </>}

                </Row>
            </DarkHeader >
        );
    }
}






